import { type VariantProps } from 'class-variance-authority'

import { cn } from '../../../../lib/utils.ts'

import { ItemGroupContext, type ItemSize } from './item-group-context.ts'
import { itemGroupVariants } from './item.variants.ts'

export function ItemGroup(props: ItemGroup.Props) {
  const { className, variant = 'default', size, children, ...rest } = props
  return (
    <ItemGroupContext.Provider value={{ size: size ?? 'medium', surfaceOwner: 'group' }}>
      <div role="list" data-slot="item-group" className={cn(itemGroupVariants({ variant, className }))} {...rest}>
        {children}
      </div>
    </ItemGroupContext.Provider>
  )
}
export namespace ItemGroup {
  type Variants = NonNullable<VariantProps<typeof itemGroupVariants>>
  export type Props = React.ComponentProps<'div'> & {
    /** Framed list, or divided rows without the frame. @default 'default' */
    variant?: NonNullable<Variants['variant']> | undefined
    /** Inherited by Item.Root children; an explicit Root size wins. @default 'medium' */
    size?: ItemSize | undefined
  }
}
